import { BaseModel } from '../../_base/crud';
import { Address } from './address.model';
import { SocialNetworks } from './social-networks.model';

export class User extends BaseModel {
    id: number;
    _id: string;
    username: string;
    password: string;
    email: string;
    otp: number;
    accessToken: string;
    refreshToken: string;
    roles: number[];
    pic: string;
    name: string;
    occupation: string;
	organization: string;
	phone: string;
    address: Address;
    socialNetworks: SocialNetworks;
    userRole: [];
    admin: Boolean;
    isAdmin?: Boolean;
    plantAdmin: Boolean;
    isPlantAdmin?: Boolean;
    optWhatsapp: Boolean;
    internal: Boolean;
    modelRetraining: Boolean;
    graphViewPreference?: GraphViewPreference;
    docPreferences?: UserPreferences;
    notificationSettings: {
        newAnomalyAlerts: notificationChannelSchema,
        newThresholdAlerts: notificationChannelSchema,
        AssignedAsAlertOwner: notificationChannelSchema,
        AssignedAsAlertWatcher: notificationChannelSchema,
        updatesOnOwnedAlerts: notificationChannelSchema,
        updatesOnWatchedAlerts: notificationChannelSchema,
        modelRetraining: notificationChannelSchema
    };
    audibleAlarmSettings?: {
        newHighAnomalyAlerts?: boolean,
        newLowAnomalyAlerts?: boolean,
        newThresholdAlerts?: boolean
    };
    moduleAccess: Array<{
        m: Number, // 1 - System, 2 - Model Wizard, 3 - Alert, 4 - Dashboard, 5 - Advanced Analysis,
        r: Boolean,
        w: Boolean
    }>

    system: [];
    unit: [];
    facility: any[];
    facilityAdminList: any[];
    facilityDetails: any[];
    enterprise: string;
    notifications : any;
    gCaptchaResponse: String;
    active?: boolean;
    reason?: string;

    clear(): void {
        this.id = undefined;
        this._id = '';
        this.username = '';
        this.password = '';
        this.email = '';
        this.otp = undefined;
        this.roles = [];
        this.userRole = [];
        this.name = '';
        this.accessToken = 'access-token-';
        this.refreshToken = 'access-token-';
        this.pic = './assets/media/users/default.jpg';
        this.occupation = '';
        this.organization = '';
        this.phone = '';
        this.plantAdmin = false;
        this.optWhatsapp = false;
        this.internal = false;
        this.address = new Address();
        this.address.clear();

        this.admin = false;

        this.system = [];
        this.facility = [];
        this.facilityDetails = [];
        this.enterprise = "";
        this.notifications = undefined;
        this.gCaptchaResponse = ''
    }
}
export interface UserResponse {
    status: number,
    message?: string,
    data?: User,
}

interface notificationChannelSchema {
    email: boolean,
    platform: boolean
}

/** Numeric enums for graph view preferences (stable; avoid string changes). Align with backend user.js graphViewPreferenceSchema. */
export const GraphViewPref = {
    anomalyDefault: { collapsed: 0, expanded: 1 },
    timelineDefault: { collapsed: 0, expanded: 1 },
    graphShading: { shadeByAlert: 0, shadeByFailureMode: 1, removeShading: 2 },
    shutdownRegionShading: { off: 0, on: 1 },
    tagGraphHeight: { condensed: 0, normal: 1, expanded: 2 },
} as const;

export type GraphViewPreference = {
    anomalyDefault: number;  // 0=Collapsed, 1=Expanded
    timelineDefault: number; // 0=Collapsed, 1=Expanded
    graphShading: number;    // 0=shadeByAlert, 1=shadeByFailureMode, 2=removeShading
    shutdownRegionShading: number; // 0=off, 1=on
    tagGraphHeight: number;  // 0=Condensed, 1=Normal, 2=Expanded
    rcaAdvancedView?: boolean;
    /** Case management layout: true = advanced, false = simplified. */
    casesAdvancedView?: boolean;
    tagLimitsAndValues?: boolean;
    tripLine: boolean;
    alarmLine?: boolean;
    thresholdLine: boolean;
    instrumentRangeLine: boolean;
};

export type UserPreferences = {
    duplicateMergeTagsDefault?: boolean;
    [key: string]: any;
};
